import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { MessageConfig } from '@v1/core/message/message.config';
import { ConfigurationUpdateStore } from '@v1/core/update/configuration-update.store';

@Component({
  selector: 'app-configuration-update-message',
  template: `
    <p-toast key="configuration-update" position="bottom-right">
      <ng-template #message let-message>
        <section class="flex align-items-center gap-3">
          <div class="flex flex-column">
            <strong>{{ message.summary }}</strong>
            <p class="m-0 mt-1">{{ message.detail }}</p>
          </div>
          <button
            pButton
            type="button"
            size="small"
            [disabled]="updates.applying()"
            (click)="updates.applyUpdate()"
          >
            <i class="pi pi-refresh" aria-hidden="true"></i>
            {{ updates.applying() ? 'Aplicando...' : 'Actualizar ahora' }}
          </button>
        </section>
      </ng-template>
    </p-toast>
  `,
  imports: [ButtonModule, Toast],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateMessage {
  protected readonly updates = inject(ConfigurationUpdateStore);
  private readonly messages = inject(MessageService);

  public constructor() {
    effect(() => {
      if (!this.updates.available()) {
        this.messages.clear('configuration-update');
        return;
      }

      this.messages.clear('configuration-update');
      this.messages.add({
        ...MessageConfig,
        key: 'configuration-update',
        severity: 'info',
        summary: 'Actualización disponible',
        detail: 'Hay una nueva versión lista para usar.',
        sticky: true,
      });
    });
  }
}
